export default "__VITE_ASSET__b9de7f79__"